!(function (doc, win) {
    let docele = doc.documentElement
    let evt = 'onorientationchange' in window ? 'onorientationchange' : 'resize'
    let fn = function () {
        let width = docele.clientWidth;
        width && (docele.style.fontSize = (width / 19.2) + 'px')
    }
    win.addEventListener(evt, fn, false)
    doc.addEventListener('DOMContentLoaded', fn, false)
}(document, window))